// 引入
import axios from "axios"
import { Notify } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';

// 环境 
// 创建实例时设置配置的默认值
//获取配置好的路径
let baseUrl = window.global_config.BASE_URL;
var instance = axios.create({
    baseURL: baseUrl,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        "authorization": '1',
    },
    // withCredentials :true,
});

/****** request拦截器==>对请求参数做处理 ******/
instance.interceptors.request.use(config => { // 请求拦截 在发送请求之前做些什么
    // 请求成功做的事情 configData 中包含：url、method等信息
    // console.log(config+'11111111111111111');
    const token = localStorage.getItem("token");
    // if (token) {
    config.headers['token'] = token;
    // }
    return config
}, error => { // 请求失败做的事情
    Notify.error({
        Notify: '请求超时!'
    });
    return Promise.resolve(error);
    // return Promise.reject(error)
})

/****** respone拦截器==>对响应做处理 ******/
instance.interceptors.response.use(
    async(response) => { //成功请求到数据
        // console.log('response');
        // console.log(response);
        // console.log('wwwwwwwwwwwww');
        const code = response.status;
        if (code === 200 || code === '200') {
            // console.log(response)
            return response;
            // } else if (code === 401) {
            //   if (await refreshToken()) {
            //     console.log('token 刷新');
            //     return instance(response.config);
            //   }
        } else {
            // 非200请求抱错
            console.log(response)
            throw Error(response.data.errorMsg || '服务异常');
        }
    },
    error => { //响应错误处理
        if (error.response == null || error.response == undefined || error.response.status == undefined) {
            // console.log('kkkkkk');
            Notify.error({
                Notify: '服务器被吃了⊙﹏⊙∥'
            });
        } else {

            const code = error.response.status;
            console.log(code)
            switch (code) {
                case 400:
                    // Dialog({ type: 'warning', message: error.response.data.errMsg });
                    Toast.clear();
                    Dialog.alert({
                        message: error.response.data.errMsg,
                        confirmButtonColor: '#108EE9'
                            // confirmButtonText: 'X'
                    })
                    break

                case 403:
                    Dialog({ type: 'warning', message: '跨域拒绝访问' });
                    break

                case 404:
                    Dialog({ type: 'warning', message: '请求地址出错' });
                    break

                case 408:
                    Dialog({ type: 'warning', message: '请求超时' });
                    break

                case 500:
                    Dialog({ type: 'warning', message: '服务器内部错误' });
                    break

                case 501:
                    Dialog({ type: 'warning', message: '服务未实现' });
                    break

                case 502:
                    Dialog({ type: 'warning', message: '网关错误' });
                    break

                case 503:
                    Dialog({ type: 'warning', message: '服务不可用' });
                    break

                case 504:
                    Dialog({ type: 'warning', message: '网关超时' });
                    break

                case 505:
                    Dialog({ type: 'warning', message: 'HTTP版本不受支持' });
                    break

                default:
                    Dialog({ type: 'warning', message: '服务发生错误' });
            }
        }
        return Promise.resolve(error);
        // return Promise.reject(error)
    }
);
export default instance;


//  method方法，对应get/post/put/delete请求
//  @param {String} url [请求的url地址]
//  @param {Object} params [请求时携带的参数]

/**
 * http封装
 * @param {请求url} url 
 * @param {请求方法get/post/put/delete} method 
 * @param {请求参数} params 
 * 注：根据业务需求，delete用路径参数，需要单独区分
 */

//  export function http(url,method,id, params){

//   return http(url+"/"+id,method,params)
//  }
export function http(url, method, data, type, getStr) {

    // console.log(data+'请求数据');
    // console.log(getStr);
    let paramsData = null;

    switch (method) {
        case 'get':
            // paramsData = {data};
            // paramsData = {data};

            if (getStr) {
                console.log(paramsData)
                paramsData = data;
            } else {
                paramsData = type === true ? `/${data}` : {
                    data
                };
            }

            // paramsData = typeof data === 'object' ? {data} :  `/${data}` ;
            break;
        case 'post':
            paramsData = data;
            break;
        case 'put':
            // console.log(data+'ddddd');
            // console.log(typeof data);
            paramsData = typeof data === 'object' ? data : `/${data}`;
            // if(type){
            //   paramsData = `/${data}`;
            // }
            // console.log(paramsData+'wwwww');
            break;
        case 'delete':
            // paramsData = `/${params}`;
            // console.log(typeof paramsData);
            paramsData = typeof data === 'object' ? {
                params: data
            } : `/${data}`;
            break;

    }

    return new Promise((resolve, reject) => {
        //请求格式： url/id
        if (method === 'put' || type === true) {
            // console.log(JSON.stringify(data));
            var methodUrl = typeof data === 'object' ? url : url + paramsData;
            // console.log(methodUrl);
            instance[method.toLowerCase()](methodUrl, paramsData)
                .then(res => {
                    if (res.result || res.data.result) {
                        resolve(res && res.data);
                    } else {
                        reject(res && res.data);
                        // console.log(res.data.errorMsg);
                        // Notify.error({Notify: res.data.errorMsg || res.errorMsg});
                    }

                })
                .catch(err => {
                    reject(err.data)
                })
        }
        //请求格式： url?filter=data
        else if (method === 'get' && getStr) {
            console.log(method)
            var methodUrl = url + '?' + getStr + '=' + paramsData;
            instance[method.toLowerCase()](methodUrl, paramsData)
                .then(res => {
                    console.log(res)
                    if (res.result || res.data.result) {
                        resolve(res && res.data);
                    } else {
                        reject(res && res.data);
                    }
                })
                .catch(err => {
                    console.log(err)
                    reject(err.data)
                })
        }
        //请求格式：{data}
        else {
            instance[method.toLowerCase()](url, paramsData)
                .then(res => {
                    // console.log(res)
                    if (res.result || res.data.result) {
                        resolve(res && res.data);
                    } else {
                        reject(res && res.data);
                        console.log(res.data);
                        // Notify.error({Notify: res.data.errorMsg || res.errorMsg});
                    }
                })
                .catch(err => {
                    console.log(err)
                    reject(err.data)
                })
        }

    })
}


// WEBPACK FOOTER //
// ./src/axios/http.js